/**
 * Corner radius of the house controls' `rounded` variant (Button, TextInput
 * and the bank's segmented control): visibly softer than the 4px default,
 * well short of a pill on a 40px control. Opt-in per control, so a scene can
 * round its own inputs and buttons without changing the rest of Lixani.
 */
export const ROUNDED_CONTROL_RADIUS = 12;

/** The same for `size="small"` (34px) controls. */
export const ROUNDED_CONTROL_RADIUS_SMALL = 10;
